import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const OptionHeader: StyleRule = () => ({
    position: 'relative',
    margin: pxArrayToRem([0, 18]),
});

export const Title: StyleRule<{ expanded: boolean }> = ({
    theme,
    expanded,
}) => ({
    paddingTop: pxToRem(20),
    fontSize: pxToRem(14),
    letterSpacing: 'normal',
    marginBottom: pxToRem(expanded ? 7 : 12),
    color: theme.siteVariables.colors.grey[300],
});

export const Indicator: StyleRule<{ expanded: boolean }> = ({
    expanded,
    theme,
}) => ({
    position: 'absolute',
    top: '50%',
    right: 0,
    transition: 'transform 150ms',
    transformOrigin: 'center',
    transform: expanded ? `rotate(180deg)` : `rotate(0deg)`,
    [`& .${svgIconClassName}`]: {
        display: 'block',
        marginBottom: 0,
        '& svg path': {
            fill: theme.siteVariables.colors.charcoal['250'],
        },
    },
});
